import { Alert, Grid, LinearProgress, Typography } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { AutContext } from "../../aut/context/AutContext";
import { PerfilForm } from "../../ui/components/PerfilForm";
import { AprLayout } from "../layout/AprLayout";
import { cfg } from "../../configuracion";
import { md5 } from "../../aut/md5";
import { IdiomaContext } from "../../context/IdiomaContext";
import { updateResidente } from "../../aut/services/updateResidente";

export const AprPerfilPage = () => {
  const [mostrarCargando, setMostrarCargando] = useState(false);
  const [mostrarError, setMostrarError] = useState(null);
  const [mostrarCompletado, setMostrarCompletado] = useState(null);
  const { cad, idioma } = useContext(IdiomaContext);
  const { usuario, iniciarSesion, cerrarSesion } = useContext(AutContext);
  
  const onDatosEmitidos = async (ret) => {
    console.log("% Datos emitidos desde PerfilForm:", ret); // Log para verificar la recepción de datos
    setMostrarCargando(true);
    setMostrarError(null);
    console.log("Datos emitidos:", ret);

    // Extrae token del usuario
    const {authToken} = usuario;
    const res = await updateResidente(
      idioma,
      {
        ...ret,
        idioma: idioma,
        clave: ret.clave ? md5(ret.clave) : null,
      },
      // Mandamos el token del usuario para autenticación.
      authToken
    );
    if (res?.datos) {
      setMostrarCompletado("Sus datos han sido guardados con éxito");
      /*
      const { nif, clave } = ret;
      iniciarSesion(nif, md5(clave));
      */
    }
    setMostrarCargando(false);
  };

  const checkToken = async (token) => {
      let respuesta = {
        datos: null,
        error: null,
      };
      try {
        const url = `${cfg.apiUrl}/vivo`;
        const resp = await fetch(url, {
          method: "GET",
          headers: {
            "Accept-Language": "en",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            
            // Deshabilitar provisionalmente la caché
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
            Expires: "0"
          },
        });
  
        const datos = await resp.json();
  
        if (resp.status === 200) {
          respuesta = { ...respuesta, datos };
        } else {
          respuesta = { ...respuesta, error: datos };
          cerrarSesion();
        }
      } catch (error) {
        respuesta = { ...respuesta, error };
        cerrarSesion();
      }
      return respuesta;
    };
  
  
    useEffect(() => {
      //console.log('Holis', usuario, new Date());
      
      checkToken(usuario.authToken)
        .then((resultado) => {
          //console.log('Aliviao', resultado);
        })
        .catch((error) =>
          console.error("Error en la solicitud de peticiones:", error)
        );
    }, []);

  return (
    <AprLayout>
      <Grid
        container
        item
        xs={10}
        sx={{
          mt: 5,
          p: 2,
          borderRadius: 2,
          borderWidth: 2,
          borderStyle: "solid",
          borderColor: "secondary.main",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            pl: 2,
            pt: 1,
            pb: 2,
            color: "primary.main",
          }}
        >
          {cad("MIS_DATOS")}
        </Typography>
        <PerfilForm perfil={usuario} onEmitirDatos={onDatosEmitidos} />
      </Grid>
      <Grid item xs={8} mt={5}>
        {mostrarCargando && (
          <Alert
            variant="outlined"
            severity="info"
            icon={false}
            sx={{ backgroundColor: "white" }}
          >
            {cad("POR_FAVOR_ESPERE")}
            <LinearProgress color="success" />
          </Alert>
        )}
      </Grid>
      <Grid item xs={8} mt={1}>
        {mostrarError && (
          <Alert variant="filled" severity="error">
            {mostrarError}
          </Alert>
        )}
      </Grid>
      <Grid item xs={8} mt={1}>
        {mostrarCompletado && (
          <Alert variant="filled" severity="success">
            {mostrarCompletado}
          </Alert>
        )}
      </Grid>
    </AprLayout>
  );
};
